


























































































import Vue from 'vue';
import LabelMixin from '@/mixins/labelMixin';

export default Vue.extend({
  mixins: [LabelMixin],
  props: {},
  data() {
    return {
      items: [
        {
          title: 'accessibilityStatement.section.information.title',
          issues: [
            {
              text: 'accessibilityStatement.section.information.issues.0.text',
              link: '#wcag-3-3-1',
              wcag: 'WCAG 3.3.1',
              description: 'accessibilityStatement.section.information.issues.0.description',
            },
            {
              text: 'accessibilityStatement.section.information.issues.1.text',
              link: '#wcag-3-3-2',
              wcag: 'WCAG 3.3.2',
              description: 'accessibilityStatement.section.information.issues.1.description',
            },
            {
              text: 'accessibilityStatement.section.information.issues.2.text',
              link: '#wcag-3-3-3',
              wcag: 'WCAG 3.3.3',
              description: 'accessibilityStatement.section.information.issues.2.description',
            },
          ],
        },
      ] as AccessibilitySection[],
    };
  },
});
